module.exports = __webpack_public_path__ + "b6440b0b41aee5c8e2bdf538ad97b3ad.png";